<!-- Button -->
<!-- <button mat-icon-button [matMenuTriggerFor]="userActions">
    <span class="relative">
        <mat-icon [svgIcon]="'heroicons_outline:cog'"></mat-icon>
    </span>
</button>

<mat-menu [xPosition]="'before'" #userActions="matMenu">
    <button mat-menu-item (click)="redirectSettings('/forms/list')">
        <mat-icon [svgIcon]="'heroicons_outline:view-list'"></mat-icon>
        <span>Manage Forms</span>
    </button>
    <button mat-menu-item (click)="redirectSettings('/users/list')">
        <mat-icon [svgIcon]="'heroicons_outline:user-add'"></mat-icon>
        <span>Manage Users</span>
    </button>
</mat-menu> -->

<button mat-icon-button (click)="openSettingsDrawer()">
    <span class="relative">
        <mat-icon [svgIcon]="'heroicons_outline:cog'"></mat-icon>
    </span>
</button>
